import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './InsCheckbox.scss'

class InsCheckbox extends Component {
  static propTypes = {
    label: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.object.isRequired
    ]),
    name: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.number.isRequired,
      PropTypes.object.isRequired
    ]),
    onClick: PropTypes.func,
    checked: PropTypes.bool
  }

  static defaultPropTypes = {
  }

  render() {
    const { 
      label,
      name,
      onClick,
      link,
      checked
    } = this.props    
    let className = `ins_input ins_input_checkbox`
    return (
      <div className={className+' mb20'}>
        <input 
          id={name} 
          name={name}
          onClick={onClick}
          type='checkbox'
          defaultChecked={checked}
        />
        <label htmlFor={name}>
          {link ? 
            <a href={link} target="_blank" rel="noopener noreferrer">{label}</a>
          :
            label
          }
        </label>
      </div>
    )
  }
}

export default InsCheckbox
